import { useCallback } from 'react';

import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { useCreateImportJobMutation } from '@/modules/corporate/modules/bulk-import/graphql/mutations/generated/createImportJob';
import { JobInputPropsInput, JobPurposeEnum, JobSettingsInput } from '@/types/schema';

interface ExportJobParams {
  purpose: JobPurposeEnum;
}

const useExportJobMutation = ({ purpose }: ExportJobParams) => {
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();
  const [{ fetching }, executeCreateImportJob] = useCreateImportJobMutation();

  const onExport = useCallback(
    async (input: JobInputPropsInput, settings?: JobSettingsInput) => {
      const res = await executeCreateImportJob({ input: { purpose, input, settings } });

      if (res.error) {
        showDefaultErrorSnackbar();
      }
      return res;
    },
    [executeCreateImportJob, purpose, showDefaultErrorSnackbar],
  );

  return { fetching, onExport };
};

export default useExportJobMutation;
